// Monta a lista de figuras exibidas no resultado da consulta, na ordem em que
// aparecem na tela. Consulta espacial devolve ate tres figuras; heatmap devolve
// uma. Figura ausente nao entra na lista.

export interface DownloadFile {
  filename: string;
  content: string;
}

export interface ObservedDataImages {
  observedData?: string;
  climatology?: string;
  anomaly?: string;
  heatmap?: string;
}

const FILENAMES: Record<keyof ObservedDataImages, string> = {
  observedData: 'dados_observados',
  climatology: 'climatologia',
  anomaly: 'anomalia',
  heatmap: 'heatmap',
};

// A ordem segue a exibicao na tela para o zip sair na mesma sequencia.
const SPATIAL_ORDER: (keyof ObservedDataImages)[] = ['observedData', 'climatology', 'anomaly'];

export default function buildDownloadFiles(
  images: ObservedDataImages,
  isHeatmap: boolean,
): DownloadFile[] {
  const keys: (keyof ObservedDataImages)[] = isHeatmap ? ['heatmap'] : SPATIAL_ORDER;

  return keys
    .filter((key) => Boolean(images[key]))
    .map((key) => ({
      filename: `${FILENAMES[key]}.png`,
      content: images[key] as string,
    }));
}
